<div [formGroup]="mfkInformationFormGroup">
    <h2 class="page-header" id="mfk">Mfk Information <small class="text-danger">Required if Submitting to Workflow</small></h2>
    <hr />
    <div class="mb-3 row">
        <label for="depositMfk" class="col-2 col-form-label text-end" style="padding-top: 1.25rem;">Deposit MFK</label>
        <div class="col">
            <uiowa-mfk-input [mfk]="mfkInformation.depositMfk" [options]="depositMfkOptions" (mfkChange)="onDepositMfkChange($event)"></uiowa-mfk-input>
            <div *ngIf="depositMfk.invalid && depositMfk.errors.fieldLength && showErrors" class="text-danger">
                <small>Deposit MFK is required.</small>
            </div>
            <div *ngIf="depositMfk.invalid && depositMfk.errors.invalidUIHCIacct && showErrors" class="text-danger">
                <small>Deposit MFK Iact must be 1100 or 1120 or start with a 4 when using a UIHC Org.</small>
            </div>
            <div *ngIf="depositMfk.invalid && depositMfk.errors.invalidIacct && showErrors" class="text-danger">
                <small>Deposit MFK Iact must start with a 4.</small>
            </div>
            <div *ngIf="depositMfk.invalid && depositMfk.errors.invalid4598Iacct && showErrors" class="text-danger">
                <small>Deposit MFK Iact can't be 4598.</small>
            </div>
            <div *ngIf="depositMfk.invalid && depositMfk.errors.invalid" class="text-danger">
                <small>
                    The <strong>PeopleSoft MFK validation tool</strong> returned this error: <br />
                    {{depositMfk.errors.invalid.message}}.
                </small>
            </div>
        </div>
    </div>
    <div class="mb-3 row">
        <label for="chargebackMfk" class="col-2 col-form-label text-end" style="padding-top: 1.25rem;">Fee MFK</label>
        <div class="col">
            <uiowa-mfk-input [mfk]="mfkInformation.chargebackMfk" [options]="chargebackMfkOptions" (mfkChange)="onChargebackMfkChange($event)"></uiowa-mfk-input>
            <div *ngIf="chargebackMfk.invalid && chargebackMfk.errors.fieldLength && showErrors" class="text-danger">
                <small>Fee MFK is required.</small>
            </div>
            <div *ngIf="chargebackMfk.invalid && chargebackMfk.errors.invalid" class="text-danger">
                <small>
                    The <strong>PeopleSoft MFK validation tool</strong> returned this error: <br />
                    {{chargebackMfk.errors.invalid.message}}.
                </small>
            </div>
        </div>
    </div>
</div>
